import React from 'react';

const CopyIcon: React.FC<{ colour?: string }> = ({ colour }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.24409 2.74412C3.40037 2.58784 3.61233 2.50004 3.83334 2.50004H11.3333C11.5544 2.50004 11.7663 2.58784 11.9226 2.74412C12.0789 2.9004 12.1667 3.11236 12.1667 3.33337V4.16671C12.1667 4.62694 12.5398 5.00004 13 5.00004C13.4602 5.00004 13.8333 4.62694 13.8333 4.16671V3.33337C13.8333 2.67033 13.5699 2.03445 13.1011 1.56561C12.6323 1.09677 11.9964 0.833374 11.3333 0.833374H3.83334C3.1703 0.833374 2.53442 1.09677 2.06558 1.56561C1.59674 2.03445 1.33334 2.67033 1.33334 3.33337V10.8334C1.33334 11.4964 1.59674 12.1323 2.06558 12.6011C2.53442 13.07 3.1703 13.3334 3.83334 13.3334H4.66668C5.12691 13.3334 5.50001 12.9603 5.50001 12.5C5.50001 12.0398 5.12691 11.6667 4.66668 11.6667H3.83334C3.61233 11.6667 3.40037 11.5789 3.24409 11.4226C3.08781 11.2663 3.00001 11.0544 3.00001 10.8334V3.33337C3.00001 3.11236 3.08781 2.9004 3.24409 2.74412Z"
        fill={colour ?? 'white'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.66668 6.66671C8.28596 6.66671 7.16668 7.78599 7.16668 9.16671V16.6667C7.16668 18.0474 8.28596 19.1667 9.66668 19.1667H17.1667C18.5474 19.1667 19.6667 18.0474 19.6667 16.6667V9.16671C19.6667 7.78599 18.5474 6.66671 17.1667 6.66671H9.66668ZM8.83334 9.16671C8.83334 8.70647 9.20644 8.33337 9.66668 8.33337H17.1667C17.6269 8.33337 18 8.70647 18 9.16671V16.6667C18 17.1269 17.6269 17.5 17.1667 17.5H9.66668C9.20644 17.5 8.83334 17.1269 8.83334 16.6667V9.16671Z"
        fill={colour ?? 'white'}
      />
    </svg>
  );
};

export default CopyIcon;
